import { AppointmentAnimationState } from '../appointment-animations';

export interface IAppointment {
    id: number;
    date: string;
    memberCount: number;
    isMemberOf: boolean;
    isLocked: boolean;
    meetingPoint: string;
    isOnline: boolean;
}

export class AppointmentViewModel implements IAppointment {
    id: number;
    date: string;
    memberCount: number;
    isMemberOf: boolean;
    isLocked: boolean;
    meetingPoint: string;
    animationState: string;
    isOnline: boolean;
   

    get activityText(): string {
        return this.memberCount === 1 ? 'ist schon dabei' : 'sind schon dabei';
    }

    constructor(appointment: IAppointment) {
        this.id = appointment.id;
        this.date = appointment.date;
        this.memberCount = appointment.memberCount;
        this.isMemberOf = appointment.isMemberOf;
        this.isLocked = appointment.isLocked;
        this.meetingPoint = appointment.meetingPoint;
        this.isOnline = appointment.isOnline;
        this.animationState = AppointmentAnimationState.initial;

    }
}
